(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[16],{

/***/ "01Ne":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__("48Ti");

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Hero_Hero; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js



var Heading_themes_themes = function themes(_ref) {
  var _classnames, _classnames2;

  var color = _ref.color;
  return {
    'heading-brand-1': {
      thRoot: classnames_default()('reset-heading font-brand leading-tight text-2xl lg:text-4xl', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "text-".concat(color), color), Object(defineProperty["a" /* default */])(_classnames, 'text-shadow-2', color === colors["a" /* COLORS */].WHITE), _classnames)),
      thSpan: 'mt-0 mb-4'
    },
    'heading-brand-2': {
      thRoot: classnames_default()('reset-heading font-brand leading-tight text-4xl lg:text-7xl', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "text-".concat(color), color), Object(defineProperty["a" /* default */])(_classnames2, 'text-shadow-2', color === colors["a" /* COLORS */].WHITE), _classnames2)),
      thSpan: 'mt-0 mb-4'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx

var __jsx = react_default.a.createElement;






var MARKDOWN_TEXT = ['break', 'emphasis', 'paragraph', 'strong', 'text'];

var Heading_markdownRootRenderer = function markdownRootRenderer(hLevel) {
  return function (props) {
    var RootElementTag = "h".concat(hLevel);

    var children = props.children,
        node = props.node,
        otherProps = Object(objectWithoutProperties["a" /* default */])(props, ["children", "node"]);

    return __jsx(RootElementTag, otherProps, children);
  };
};

var Heading_markdownNeutralRenderer = function markdownNeutralRenderer(className) {
  return function (_ref) {
    var children = _ref.children;
    return __jsx("span", {
      className: classnames_default()('last-child-mb-0', className)
    }, children);
  };
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = Heading_themes_themes({
    color: color
  })[theme],
      thRoot = _themes$theme.thRoot,
      thSpan = _themes$theme.thSpan;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_TEXT,
    className: classnames_default()(className, thRoot),
    children: children,
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Heading_markdownRootRenderer(hLevel),
      paragraph: Heading_markdownNeutralRenderer(thSpan)
    }
  });
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/heroUtils.js
var heroUtils = __webpack_require__("5xkM");

// CONCATENATED MODULE: ./src/client/components/widgets/hero/Hero.jsx

var Hero_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */












var Hero_Hero = function Hero(_ref) {
  var _ref2;

  var alt = _ref.alt,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      isLegacyMode = _ref.isLegacyMode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      url = _ref.url;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _generateBackgroundSt = Object(heroUtils["c" /* generateBackgroundStylesAndClassName */])(url),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? colors["a" /* COLORS */].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? colors["a" /* COLORS */].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? colors["a" /* COLORS */].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? colors["a" /* COLORS */].WHITE : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? colors["a" /* COLORS */].BLUE : _theming$linkBackgrou;

  var _getHeroDimensions = Object(heroUtils["e" /* getHeroDimensions */])(size, isDesktop),
      height = _getHeroDimensions.height,
      paddingBottom = _getHeroDimensions.paddingBottom,
      paddingTop = _getHeroDimensions.paddingTop;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? heroUtils["b" /* TITLE_POSITIONS */][contentPosition] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? TrackClick["a" /* TrackClick */] : react["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    as: DynamicLink["a" /* default */],
    className: 'inline-block reset-anchor hover:scale-105 transition-all',
    trackingData: tracking,
    url: link.url
  } : {};
  return Hero_jsx("div", {
    "aria-label": alt,
    className: className,
    "data-size": size,
    id: id,
    role: "img",
    style: _objectSpread({
      height: height
    }, style)
  }, Hero_jsx("div", {
    className: "relative",
    style: {
      height: height,
      paddingTop: paddingTop
    }
  }, Hero_jsx("div", {
    className: "absolute bg-center bg-cover bg-no-repeat fadeIn h-full inset-x-0 top-0 w-full ".concat(imageClassName),
    style: {
      height: height
    }
  }), (icon === null || icon === void 0 ? void 0 : icon.link) && Hero_jsx("div", {
    className: "absolute inset-0",
    style: {
      paddingTop: paddingTop,
      paddingBottom: hasOverlap ? '40px' : 0
    }
  }, Hero_jsx("div", {
    className: classnames_default()('flex h-full m-auto max-w-site overflow-hidden p-5 w-full', heroUtils["a" /* ICON_POSITIONS */][icon.position]),
    dir: "ltr"
  }, Hero_jsx("img", {
    alt: icon.alt || '',
    className: "flex-none max-h-full",
    src: icon.link,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && Hero_jsx("div", {
    className: "align-bottom flex flex-col h-full z-1 justify-end px-5 relative",
    style: {
      paddingBottom: paddingBottom
    }
  }, Hero_jsx("div", {
    className: classnames_default()("flex flex-col max-w-site mx-auto w-full ".concat(textAlignment), {
      'h-full': isHighlight
    })
  }, Hero_jsx(TitleAndSubtitleWrapperTag, titleAndSubtitleWrapperProps, Hero_jsx(Heading_Heading, {
    className: !isLegacyMode && !isHighlight && size !== 'small' ? 'lg:text-7xl' : '',
    color: titleColor,
    hLevel: hLevel,
    theme: isLegacyMode ? 'heading-brand-2' : 'heading-brand-1'
  }, title), !!subtitle && Hero_jsx(Text["a" /* Text */], {
    className: "mt-1",
    color: subtitleColor,
    text: subtitle,
    theme: "text-sans-5"
  })), !Object(lodash["isEmpty"])(countdown) && Hero_jsx(Countdown["a" /* Countdown */], {
    className: "pt-3",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && Hero_jsx("div", {
    className: classnames_default()({
      'mt-auto w-full': isHighlight
    })
  }, Hero_jsx(Button["a" /* Button */], {
    className: classnames_default()('mt-4', {
      'w-full': !isDesktop
    }),
    color: linkColor,
    colorBg: linkBackgroundColor,
    style: {
      maxWidth: isHighlight && !isDesktop ? 'none' : '17.5rem'
    },
    trackingData: tracking,
    url: link.url || '#hero-beacon'
  }, link.label)))), Hero_jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && Hero_jsx("div", {
    className: "absolute inset-0",
    style: (_ref2 = {
      /* eslint-disable no-dupe-keys */
      background: '-moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%)'
    }, Object(defineProperty["a" /* default */])(_ref2, "background", '-webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 100%)'), Object(defineProperty["a" /* default */])(_ref2, "background", 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 100%)'), _ref2)
  })), Hero_jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "48Ti":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__("w9cF");

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),

/***/ "58k+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),

/***/ "5xkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TITLE_POSITIONS; });
/* unused harmony export SIZES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHeroDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateBackgroundStylesAndClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBackgroundImageUrl; });
/* unused harmony export getBackgroundRule */
/* unused harmony export getAllBackgroundRules */
/* unused harmony export AUTO */
/* unused harmony export PREFIXES */
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("FLQK");
/* harmony import */ var _navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1cDg");
/* harmony import */ var _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lDxO");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("m1JM");


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var AUTO = '_AUTOFORMAT_';
var PREFIXES = ['webkit', 'moz', 'o', 'ms'];

var getBackgroundImageUrl = function getBackgroundImageUrl(url, width) {
  var options = {
    format: AUTO,
    url: url,
    width: width,
    height: 'auto',
    transform: 'resize',
    quality: 70
  };
  return _utils_media_server__WEBPACK_IMPORTED_MODULE_1__[/* getUrl */ "a"](options);
};

var getBackgroundRule = function getBackgroundRule(params) {
  return function (getUrlFunction) {
    return function (prefixes) {
      var id = params.id,
          url = params.url,
          width1x = params.width1x,
          width2x = params.width2x;
      return ".".concat(id, " {\n        background-image:url(").concat(getUrlFunction(url, width1x), ");\n        ").concat(prefixes.reduce(function (acc, prefix) {
        return "".concat(acc, "\n        background-image: -").concat(prefix, "-image-set(url(").concat(getUrlFunction(url, width1x), ") 1x, url(").concat(getUrlFunction(url, width2x), ") 2x);\n        ");
      }, ''), "\n      }");
    };
  };
};

var getAllBackgroundRules = function getAllBackgroundRules(params) {
  return function (getRuleFunction) {
    return "".concat(getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES));
  };
};

var ICON_POSITIONS = {
  'top-left': 'items-start justify-start',
  'top-middle': 'items-start justify-center',
  'top-right': 'items-start justify-end',
  'center-left': 'items-start sm:items-center justify-start',
  'center-middle': 'items-start sm:items-center justify-center',
  'center-right': 'items-start sm:items-center justify-end',
  'bottom-left': 'items-start sm:items-end justify-start',
  'bottom-middle': 'items-start sm:items-end justify-center',
  'bottom-right': 'items-start sm:items-end justify-end'
};
var TITLE_POSITIONS = {
  left: 'items-start rtl:text-left',
  center: 'items-center text-center',
  right: 'items-end rtl:text-right'
};
var SIZES = {
  small: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  highlightSmall: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  medium: {
    mobile: {
      height: '320px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '440px',
      paddingBottom: '100px'
    }
  },
  large: {
    mobile: {
      height: '420px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '540px',
      paddingBottom: '115px'
    }
  },
  highlight: {
    mobile: {
      height: '480px',
      paddingBottom: '40px'
    },
    desktop: {
      height: '480px',
      paddingBottom: '70px'
    }
  },
  full: {
    mobile: {
      height: '100%',
      paddingBottom: '60px'
    },
    desktop: {
      height: '100%',
      paddingBottom: '115px'
    }
  }
};
var getHeroDimensions = function getHeroDimensions(sizeProp, isDesktop) {
  var size = SIZES[sizeProp] ? SIZES[sizeProp] : SIZES.large;
  var isHighlight = sizeProp === 'highlightSmall' || sizeProp === 'highlight';
  var heroPaddingTop = isDesktop ? _navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__[/* heights */ "e"].NAVIGATION_LARGE_HEIGHT : _navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__[/* heights */ "e"].NAVIGATION_NARROW_HEIGHT;
  var highlightPaddingTop = isDesktop ? '80px' : '40px';
  return {
    height: isDesktop ? size.desktop.height : size.mobile.height,
    paddingBottom: isDesktop ? size.desktop.paddingBottom : size.mobile.paddingBottom,
    paddingTop: isHighlight ? highlightPaddingTop : heroPaddingTop
  };
};
var generateBackgroundStylesAndClassName = function generateBackgroundStylesAndClassName(url) {
  if (!url) {
    return {
      style: '',
      className: ''
    };
  }

  var componentId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_4__[/* generateUniqueId */ "b"])([url]);
  var widths = _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_3__[/* defaultDictionnary */ "a"].getWidthRanges();
  var params = {
    id: componentId,
    url: url
  };
  return {
    className: componentId,
    style: "".concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[0],
      width2x: widths[1]
    }))(getBackgroundRule), "\n      @media all and (min-width: 22.51em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[2],
      width2x: widths[3]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 40.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[2],
      width2x: widths[3]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 64.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[3],
      width2x: widths[4]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 76.26em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[4],
      width2x: widths[4]
    }))(getBackgroundRule), "\n      }")
  };
};


/***/ }),

/***/ "FZlW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__("58k+");

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),

/***/ "G8Pb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__("48Ti");
var encode = __webpack_require__("FZlW");
var decode = __webpack_require__("01Ne");
var build = __webpack_require__("tDlq");
var isValid = __webpack_require__("gM+Z");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__("cHLG") || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),

/***/ "MIfU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__("G8Pb");


/***/ }),

/***/ "cHLG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),

/***/ "gM+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__("48Ti");

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),

/***/ "m1JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateUniqueId; });
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("MIfU");
/* harmony import */ var shortid__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(shortid__WEBPACK_IMPORTED_MODULE_0__);

var cleanupId = function cleanupId(text) {
  return text ? "".concat(text).replace(/[^a-zA-Z0-9]/g, '').toLocaleLowerCase() : '';
};
var generateUniqueId = function generateUniqueId(list) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (list.length) {
    var id = list.filter(Boolean).map(cleanupId).filter(Boolean).join('-');

    if (id) {
      return "".concat(prefix).concat(id).toLocaleLowerCase();
    }
  } // should not occurs, it breaks the server/client reconciliation


  return "".concat(prefix).concat(shortid__WEBPACK_IMPORTED_MODULE_0___default.a.generate()).toLocaleLowerCase();
};

/***/ }),

/***/ "mmhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Countdown_Countdown; });

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/classnames/index.js
var classnames = __webpack_require__("O94r");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /Users/zeinedineahmednah/clubmed/cm-b2c/node_modules/moment/moment.js
var moment = __webpack_require__("wgY5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.themes.js




var defaultValueSizes = {
  small: {
    w: '2.3rem',
    valueTextSize: 'text-md',
    labelTextSize: 'text-xxs'
  },
  large: {
    w: '3.0625rem',
    valueTextSize: 'text-2xl',
    labelTextSize: 'text-xs'
  }
};
var themes = {
  "default": Object(lodash["memoize"])(function (_ref) {
    var size = _ref.size,
        color = _ref.color;
    var textColor = color ? color : colors["a" /* COLORS */].WHITE;
    var textShadow = textColor === colors["a" /* COLORS */].WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex rtl:flex-row items-stretch',
      thItem: "flex flex-col items-center justify-between mx-1 text-center text-".concat(textColor),
      thLabel: "font-bold leading-one mb-1 ".concat(textShadow, " uppercase ").concat(defaultValueSizes[size].labelTextSize),
      thValue: "flex font-bold items-center justify-center rounded-small text-center ".concat(textShadow, " leading-tight ").concat(defaultValueSizes[size].valueTextSize),
      thValueStyle: {
        width: defaultValueSizes[size].w
      }
    };
  }),
  offerPush: function offerPush(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
        bgColor = _ref2.bgColor;
    return {
      thRoot: classnames_default()("font-brand px-1 rounded-tiny text-".concat(color), Object(defineProperty["a" /* default */])({}, "bg-".concat(bgColor), !!bgColor)),
      thItem: "inline mx-px text-center text-".concat(color, " text-xs uppercase"),
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: 'auto'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx







var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var UNITS = ['days', 'hours', 'minutes', 'seconds'];

function getStateFromProps(_ref) {
  var dateTimeEnd = _ref.dateTimeEnd;
  var now = moment_default()();
  return {
    timeRemaining: now.isBefore(dateTimeEnd) ? moment_default.a.duration(moment_default()(dateTimeEnd).diff(now)) : 0
  };
}

var Countdown_Countdown = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Countdown, _Component);

  var _super = _createSuper(Countdown);

  function Countdown(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Countdown);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "tick", function () {
      var dateTimeEnd = _this.props.dateTimeEnd;
      var timeRemaining = moment_default.a.duration(moment_default()(dateTimeEnd).diff(moment_default()()));

      _this.setState({
        timeRemaining: timeRemaining
      }, function () {
        if (timeRemaining.asSeconds() > 0) {
          _this.rafID = dist["windowWrapper"].requestAnimationFrame(_this.tick);
        }
      });
    });

    _this.state = getStateFromProps(props);
    return _this;
  }

  Object(createClass["a" /* default */])(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.shouldDisplay()) {
        this.rafID = dist["windowWrapper"].requestAnimationFrame(this.tick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      dist["windowWrapper"].cancelAnimationFrame(this.rafID);
    }
  }, {
    key: "shouldDisplay",
    value: function shouldDisplay() {
      var timeRemaining = this.state.timeRemaining; // $FlowFixMe

      return timeRemaining > 0 && timeRemaining.months() === 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.shouldDisplay()) {
        return null;
      }

      var _this$props = this.props,
          className = _this$props.className,
          theme = _this$props.theme,
          dataTestId = _this$props.dataTestId;
      var timeRemaining = this.state.timeRemaining;

      var _themes$theme = themes[theme](this.props),
          thItem = _themes$theme.thItem,
          thLabel = _themes$theme.thLabel,
          thRoot = _themes$theme.thRoot,
          thValue = _themes$theme.thValue,
          thValueStyle = _themes$theme.thValueStyle;

      return __jsx("div", {
        className: classnames_default()(className, thRoot),
        role: "timer",
        "data-testid": dataTestId
      }, UNITS.map(function (unit) {
        // $FlowFixMe
        var current = timeRemaining[unit]();
        var currentTime = current < 10 ? "0".concat(current) : current;
        return __jsx("div", {
          className: thItem,
          key: unit
        }, __jsx("div", {
          className: thValue,
          style: thValueStyle
        }, currentTime), __jsx("div", {
          className: thLabel
        }, " ", _this2.props[unit]));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      return getStateFromProps(nextProps);
    }
  }]);

  return Countdown;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Countdown_Countdown, "defaultProps", {
  size: 'large',
  theme: 'default'
});

/***/ }),

/***/ "tDlq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__("FZlW");
var alphabet = __webpack_require__("48Ti");

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),

/***/ "w9cF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ })

}]);